import { render, staticRenderFns } from "./NpaHistoryChangesView.vue?vue&type=template&id=30619f19&scoped=true"
import script from "./NpaHistoryChangesView.vue?vue&type=script&lang=js"
export * from "./NpaHistoryChangesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30619f19",
  null
  
)

export default component.exports